
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getSubPagesDetails } from "../../services/footerServices";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faShare } from "@fortawesome/free-solid-svg-icons";

const SubPage = () => {
  const [details, setDetails] = useState([]);
  const [copied, setCopied] = useState(false);
  const { search, state } = useLocation();
  let queryParams = search?.split("?")[1]?.split("&") || [];
  const decodedProductId = atob(queryParams?.length > 0 ? queryParams[0] : "");
  let stateId = state?.stateId ? state?.stateId : +decodedProductId;
  useEffect(() => {
    if (stateId) {
      getSuppageDetails(stateId);
    }
  }, [stateId]);

  const getSuppageDetails = async (subPageId) => {
    try {
      const response = await getSubPagesDetails(subPageId);
      if (response.status_code === 200) {
        setDetails(response.data);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } catch (error) {}
  };

  const encodedProductId = btoa(stateId?.toString());
  let currentLocation = `${window.location.origin}${window.location.pathname}`;
  const url = `${currentLocation}?${encodedProductId || ""}`;
  const copyToClipboard = (e) => {
    e.preventDefault();
    const input = document.createElement("input");
    input.value = url;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    setCopied(true);
     setTimeout(() => {
       setCopied(false);
     }, 2000);
  };

  return (
    <div className="container mx-auto py-3">
      <div className="row align-items-center justify-content-between mb-5">
        <div className="col-7 col-xl-7">
          <h4 className="text-xl-end text-start ps-2  fw-bold ">
            {details?.page_name}
          </h4>
        </div>
        {/* <div className="col-4 d-flex justify-content-end   pe-5  col-xl-5">

        <FontAwesomeIcon icon={faShare} style={{  fontSize: 25,
                  cursor: "pointer",
                  color: "#000",}} />
          <Tooltip
            key={copied}
            title={copied ? "URL copied!" : "Share Page"}
            arrow
          >
            <IconButton
              size="small"
              sx={{
                borderRadius: "8px",
                transition: "box-shadow 0.3s ease-in-out",
                "&:hover": {
                  boxShadow: "0 0 10px var(--secondry-color)",
                },
              }}
              onClick={copyToClipboard}

            >
          
            </IconButton>
          </Tooltip>
        </div> */}
      </div>
      <p
        dangerouslySetInnerHTML={{ __html: details?.page_content }}
      ></p>
    </div>
  );
};

export default SubPage;
